<form [formGroup]="formGroup">
  <div class="d-flex flex-column gap-4">
    <app-international-address-form-grid
      controlIdPrefix="addressChange"
      [form]="formGroup.controls.address"
      [formSubmitted]="formSubmitted" />

    <ng-container *ngIf="filesRequired">
      <hr class="m-0" />

      <div class="d-flex flex-column gap-1">
        <label class="form-input-label" for="file" i18n>Document</label>
        <app-file-upload-field
          controlId="file"
          formControlName="files"
          [accept]="acceptedFileTypes"
          [multiple]="allowMultipleFiles"
          [maxFileSizeInMb]="maxFileSizeInMb"
          [submitAttempted]="formSubmitted"
          [control]="formGroup.controls.files"
          [showThumbnail]="true">
          <div class="d-flex flex-column align-items-center gap-3" input-copy>
            <img
              src="assets/icons/grey/FileUpload.svg"
              alt="Upload File"
              i18n-alt
              height="24"
              width="24"
              [style.height.rem]="1.5"
              [style.width.rem]="1.5" />
            <app-file-uploader-text
              [disabled]="formGroup.controls.files.disabled"
              descriptionText="or drag and drop .png or .jpeg up to 3MB"
              i18n-descriptionText />
          </div>
        </app-file-upload-field>
        <app-form-error
          *ngIf="formSubmitted && formGroup.controls.files.invalid"
          [errors]="formGroup.controls.files.errors"
          [customErrorMessages]="customErrorMessages.files" />
      </div>
    </ng-container>
  </div>
</form>
